import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api from '../../services/api';
import { FileText } from 'lucide-react';
import { toast } from 'sonner';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [form, setForm] = useState({ new_password: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) {
      toast.error('As senhas não coincidem');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: form.new_password });
      toast.success('Senha redefinida com sucesso!');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Token inválido ou expirado');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/icon-192.png" alt="OrcFácil" className="w-32 h-32 rounded-2xl object-cover mb-4 mx-auto block shadow-[0_0_40px_rgba(249,115,22,0.35)]" />
          <h1 className="font-heading text-3xl font-bold text-white">OrcFácil</h1>
        </div>
        <form onSubmit={handleSubmit} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 space-y-4">
          <h2 className="font-heading text-xl font-semibold text-white">Nova senha</h2>
          <div>
            <label className="field-label">Nova senha</label>
            <input type="password" required minLength={6} className="field-input" placeholder="••••••••"
              value={form.new_password} onChange={e => setForm(p => ({ ...p, new_password: e.target.value }))} />
          </div>
          <div>
            <label className="field-label">Confirmar senha</label>
            <input type="password" required className="field-input" placeholder="••••••••"
              value={form.confirm} onChange={e => setForm(p => ({ ...p, confirm: e.target.value }))} />
          </div>
          <button type="submit" disabled={loading}
            className="w-full bg-orange-500 hover:bg-orange-400 disabled:opacity-50 text-white font-semibold py-2.5 px-4 rounded-xl transition-colors">
            {loading ? 'Salvando...' : 'Redefinir senha'}
          </button>
          <p className="text-center text-sm text-zinc-500">
            <Link to="/login" className="text-orange-400 hover:text-orange-300">Voltar ao login</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
